import { Injectable } from '@angular/core';
import { default as dayjs } from 'dayjs';
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/th";
import buddhistEra from "dayjs/plugin/buddhistEra";
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { faBan, faBoxesStacked, faBullhorn, faChartLine, faClipboardList, faGear, faHouse, faLayerGroup, faMagnifyingGlassChart, faReceipt, faTags } from '@fortawesome/free-solid-svg-icons';
import { faTiktok } from '@fortawesome/free-brands-svg-icons';
import { PermissionService } from '../permission/permission.service';

dayjs.extend(buddhistEra);
dayjs.extend(relativeTime);
dayjs.locale("th");

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  dayjs = dayjs;
  navbarOpen = false;
  loading = false;

  menuList: any[] = [
    {
      section: 'สำนักงานใหญ่',
      visible: true
    },
    {
      path: '/main',
      name: 'ตัวอย่าง',
      icon: faHouse,
      visible: false,
      access: true
    },
    {
      path: '/profile',
      name: 'ข้อมูลส่วนตัว',
      icon: faUser,
      visible: false,
      access: this.permissionService.activatedRoute('/profile')
    },
    {
      path: '/purchase-analysis',
      name: 'วิเคราะห์ข้อมูลจัดซื้อ',
      icon: faMagnifyingGlassChart,
      visible: true,
      access: this.permissionService.activatedRoute('/purchase-analysis')
    },
    {
      path: '/data-analysis',
      name: 'วิเคราะห์ข้อมูลการขาย',
      icon: faChartLine,
      visible: true,
      access: this.permissionService.activatedRoute('/data-analysis')
    },
    {
      path: '/order',
      name: 'คำสั่งซื้อ',
      icon: faClipboardList,
      visible: false,
      access: this.permissionService.activatedRoute('/order')
    },
    {
      path: '/product',
      name: 'สินค้า',
      icon: faBoxesStacked,
      visible: true,
      access: true,
      isShowSub: true,
      submenu: [
        {
          path: "/product/list",
          name: 'รายการสินค้า',
          description: 'รายการสินค้า',
          visible: true,
          access: this.permissionService.activatedRoute('/product/list')
        },
        {
          path: "/product/stock",
          name: 'สต๊อกสินค้า',
          description: 'สต๊อกสินค้า',
          visible: true,
          access: this.permissionService.activatedRoute('/product/stock')
        },
      ],
    },
    {
      path: '/product-set',
      name: 'สินค้าเซ็ต',
      icon: faLayerGroup,
      visible: true,
      access: true,
      isShowSub: true,
      submenu: [
        {
          path: "/product-set/list",
          name: 'รายการเซ็ต',
          description: 'รายการเซ็ต',
          visible: true,
          access: this.permissionService.activatedRoute('/product-set/list')
        },
        {
          path: "/product-set/stock",
          name: 'สต๊อกเซ็ต',
          description: 'สต๊อกเซ็ต',
          visible: true,
          access: this.permissionService.activatedRoute('/product-set/stock')
        },
        {
          path: "/product-set/create",
          name: 'สร้างเซ็ตสินค้า',
          description: 'สร้างเซ็ตสินค้า',
          visible: false,
          access: this.permissionService.activatedRoute('/product-set/create')
        },
        {
          path: "/product-set/detail",
          name: 'รายละเอียดเซ็ตสินค้า',
          description: 'รายละเอียดเซ็ตสินค้า',
          visible: false,
          access: this.permissionService.activatedRoute('/product-set/detail')
        },
      ],
    },
    {
      path: '/tiktok-set/list',
      name: 'TikTok SET',
      icon: faTiktok,
      visible: true,
      access: this.permissionService.activatedRoute('/tiktok/list')
    },
    {
      path: '/price-list',
      name: 'Price List',
      icon: faTags,
      visible: true,
      access: this.permissionService.activatedRoute('/price-list')
    },
    {
      path: '/stock-promotion-list',
      name: 'Stock Promotion',
      icon: faBullhorn,
      visible: true,
      access: this.permissionService.activatedRoute('/stock-promotion-list')
    },
    {
      path: '/setting',
      name: 'ตั้งค่า',
      icon: faGear,
      visible: true,
      access: this.permissionService.activatedRoute('/setting')
    },
    {
      section: 'สาขา',
      visible: true,
      requiresBranch: true
    },
    {
      path: '/branch/data-analysis',
      name: 'วิเคราะห์ข้อมูลการขาย',
      icon: faChartLine,
      visible: true,
      requiresBranch: true,
      access: this.permissionService.activatedRoute('/branch/data-analysis')
    },
    {
      path: '/branch/order',
      name: 'คำสั่งซื้อ',
      icon: faClipboardList,
      visible: true,
      requiresBranch: true,
      access: this.permissionService.activatedRoute('/branch/order')
    },
    {
      path: '/branch/receipt',
      name: 'ใบรับเข้า',
      icon: faReceipt,
      visible: true,
      requiresBranch: true,
      access: this.permissionService.activatedRoute('/branch/receipt')
    },
    {
      path: '/branch/product',
      name: 'สินค้า',
      icon: faBoxesStacked,
      visible: true,
      requiresBranch: true,
      access: true,
      isShowSub: true,
      submenu: [
        {
          path: '/branch/product/list',
          name: 'รายการสินค้า',
          description: 'รายการสินค้า',
          visible: true,
          access: this.permissionService.activatedRoute('/branch/product/list')
        },
        {
          path: '/branch/product/stock',
          name: 'สต๊อกสินค้า',
          description: 'สต๊อกสินค้า',
          visible: true,
          access: this.permissionService.activatedRoute('/branch/product/stock')
        },
      ],
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      icon: faBan,
      visible: false,
      access: true
    }
  ]

  constructor(
    private permissionService: PermissionService
  ) { }

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  closeToggleNevbar() {
    this.navbarOpen = false
  }

  screenLoader(value: boolean) {
    this.loading = value;
  }

}
